<body>
  <div class="grid-overlay">
    <div class="header">
      <div class="logo">
        <a routerLink="/my-portals">
          <img
            src="../../../../assets/images/BRAND2.png"
            alt="logo de Billcentrix" />
          </a>
        </div>
      </div>
      <div class="setting-data">
        <div class="second-headboard customer-affiliation-header">
          <div>
            <h1></h1>
            <h1>
              {{
              mode === "onetime_payment"
              ? ("addClient.titles.payment" | translate)
              : ("addClient.titles.subscription" | translate)
              }}
            </h1>
            <p>
              {{
              mode === "onetime_payment"
              ? ("addClient.descriptions.payment" | translate)
              : ("addClient.descriptions.subscription" | translate)
              }}
            </p>
          </div>
          @if (mode === 'subscription') {
            <button
              mat-stroked-button
              type="button"
              class="import-customers-btn"
              [disabled]="!canCreateCustomer()"
              (click)="goToImportCustomers()">
              <mat-icon>upload</mat-icon>
              {{ "addClient.buttons.importCustomers" | translate }}
            </button>
          }
        </div>
        <div class="general-data">
          <mat-accordion>
            <mat-expansion-panel
              [expanded]="isOpenSearchPanel"
              (opened)="setSearchPanelState(true)"
              (closed)="setSearchPanelState(false)">
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-icon>person_search</mat-icon>
                  {{ "addClient.form.customerSearch" | translate }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="customer-search-standalone">
                <mat-icon class="customer-search-standalone__icon">person_search</mat-icon>
                @if (!mostrarFormularioCompleto) {
                  <p class="customer-search-standalone__subtitle">
                    {{ "addClient.descriptions.searchCustomer" | translate }}
                  </p>
                }
                <div class="items">
                  <label for="customer_search">{{ "addClient.form.customerSearch" | translate }}</label>
                  <div class="input-container">
                    <input
                      id="customer_search"
                      type="text"
                      [placeholder]="'addClient.form.customerSearchPlaceholder' | translate"
                      [formControl]="customerSearchControl"
                      (keydown.enter)="onCustomerSearchEnter($event)"
                      autocomplete="off" />
                  </div>
                  <div class="customer-search-standalone__actions">
                    <button class="continue-btn big" type="button" (click)="clearCustomerSearch()">
                      {{ "addClient.buttons.clear" | translate }}
                    </button>
                    <button class="continue-btn color big" type="button" (click)="search()">
                      {{ "addClient.buttons.search" | translate }}
                    </button>
                  </div>
                  @if (customerSearchControl.hasError('required') && customerSearchControl.touched) {
                    <small class="form-error-msg">
                      {{ "addClient.form.customerSearchRequired" | translate }}
                    </small>
                  }
                  @if (customerSearchControl.hasError('pattern') && customerSearchControl.touched) {
                    <small class="form-error-msg">
                      {{ "addClient.form.customerSearchInvalid" | translate }}
                    </small>
                  }
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
          @if (mostrarFormularioCompleto) {
            <h1>{{ "addClient.titles.customerData" | translate }}</h1>
            <form [formGroup]="clientForm">
              <div class="grid">
                <div class="left">
              <div class="items">
                <label for="email_customer">{{ "addClient.form.email" | translate }}</label>
                <input
                  id="email_customer"
                  type="email"
                  [placeholder]="'addClient.form.emailPlaceholder' | translate"
                  [formControl]="clientForm.controls['email_customer']"
                  [readonly]="customerFieldsReadOnly['email_customer']"
                  autocomplete="email" />
                @if (
                  clientForm.controls['email_customer'].hasError('required') &&
                  clientForm.controls['email_customer'].touched
                  ) {
                  <small class="form-error-msg">
                    {{ "addClient.form.emailRequired" | translate }}
                  </small>
                }
                @if (
                  clientForm.controls['email_customer'].hasError('pattern') &&
                  clientForm.controls['email_customer'].touched
                  ) {
                  <small class="form-error-msg">
                    {{ "addClient.form.emailInvalid" | translate }}
                  </small>
                }
                </div>

                    <div class="items">
                      <label for="name">{{ "addClient.form.name" | translate }}*</label>
                    <input
                      (keypress)="onlyLettersAndSpacesKey($event)"
                      [formControl]="clientForm.controls['name_customer']"
                      [readonly]="customerFieldsReadOnly['name_customer']"
                      type="text"
                      [placeholder]="'addClient.form.namePlaceholder' | translate" />
                      @if (
                        clientForm.controls['name_customer'].hasError('required') &&
                        clientForm.controls['name_customer'].touched
                        ) {
                        <small
                          class="form-error-msg">
                          {{ "addClient.form.nameRequired" | translate }}</small
                          >
                      }
                      @if (
                        clientForm.controls['name_customer'].hasError('pattern') &&
                        clientForm.controls['name_customer'].touched
                        ) {
                        <small
                          class="form-error-msg">
                          {{ "addClient.form.nameInvalid" | translate }}</small
                          >
                        }
                        @if (
                          clientForm.controls['name_customer'].hasError('maxlength') &&
                          clientForm.controls['name_customer'].touched
                          ) {
                          <small
                            class="form-error-msg">
                            {{ "addClient.form.nameMaxLength" | translate }}</small
                            >
                          }
                        </div>

                        <div class="items">
                          <label for="name">{{ "addClient.form.lastName" | translate }}*</label>
                          <input
                            (keypress)="onlyLettersAndSpacesKey($event)"
                            [formControl]="clientForm.controls['lastName_customer']"
                            [readonly]="customerFieldsReadOnly['lastName_customer']"
                            type="text"
                            [placeholder]="'addClient.form.lastNamePlaceholder' | translate" />
                            @if (
                              clientForm.controls['lastName_customer'].hasError('required') &&
                              clientForm.controls['lastName_customer'].touched
                              ) {
                              <small
                                class="form-error-msg">
                                {{ "addClient.form.lastNameRequired" | translate }}</small
                                >
                            }
                            @if (
                              clientForm.controls['lastName_customer'].hasError('pattern') &&
                              clientForm.controls['lastName_customer'].touched
                              ) {
                              <small
                                class="form-error-msg">
                                {{ "addClient.form.lastNameInvalid" | translate }}</small
                                >
                              }
                              @if (
                                clientForm.controls['lastName_customer'].hasError('maxlength') &&
                                clientForm.controls['lastName_customer'].touched
                                ) {
                                <small
                                  class="form-error-msg">
                                  {{ "addClient.form.lastNameMaxLength" | translate }}</small
                                  >
                                }
                              </div>

                              <!-- <div class="items">
                              <label for="country">Provincia*</label>
                              <div class="select-wrapper">
                                <select (change)="onProvinceChange()" [formControl]="clientForm.controls['province']">
                                  <option   selected="" value="">Seleccione un opción</option>
                                  <option *ngFor="let p of provinces" [value]="p.id" >{{p.name}}</option>
                                </select>
                                <i class="arrow"></i>
                                <small  *ngIf="clientForm.controls['province'].hasError('required') && clientForm.controls['province'].touched"
                                  class="form-error-msg"> Provincia es requerido
                                </small>
                              </div>
                            </div> -->
                            <div class="items">
                              <label for="name">{{ "addClient.form.address" | translate }}*</label>
                              <input
                                [formControl]="clientForm.controls['address']"
                                [readonly]="customerFieldsReadOnly['address']"
                                type="text"
                                [placeholder]="'addClient.form.addressPlaceholder' | translate" />
                                @if (
                                  clientForm.controls['address'].hasError('required') &&
                                  clientForm.controls['address'].touched
                                  ) {
                                  <small
                                    class="form-error-msg">
                                    {{ "addClient.form.addressRequired" | translate }}</small
                                    >
                                }
                                @if (
                                  clientForm.controls['address'].hasError('pattern') &&
                                  clientForm.controls['address'].touched
                                  ) {
                                  <small
                                    class="form-error-msg">
                                    {{ "addClient.form.addressInvalid" | translate }}</small
                                    >
                                  }
                                </div>
                                @if (mode === 'onetime_payment') {
                                  <div
                                    class="items"
                                    >
                                    <label for="amount">{{ "addClient.form.amount" | translate }}*</label>
                                    <div class="select-wrapper">
                                      <input
                                        type="number"
                                        formControlName="amount"
                                        [placeholder]="'addClient.form.amountPlaceholder' | translate"
                                        class="your-custom-input-class" />
                                        @if (
                                          clientForm.controls['amount'].hasError('required') &&
                                          clientForm.controls['amount'].touched
                                          ) {
                                          <small
                                            class="form-error-msg">
                                            {{ "addClient.form.amountRequired" | translate }}
                                          </small>
                                        }
                                      </div>
                                    </div>
                                  }
                                  @if (mode === 'onetime_payment') {
                                    <div
                                      class="items"
                                      >
                                      <label for="taxrate">{{ "addClient.form.taxRate" | translate }}*</label>
                                      <div class="select-wrapper">
                                        <input
                                          type="number"
                                          min="0"
                                          max="100"
                                          step="1"
                                          formControlName="taxrate"
                                          [placeholder]="'addClient.form.taxRatePlaceholder' | translate"
                                          class="your-custom-input-class" />
                                          @if (
                                            clientForm.controls['taxrate'].hasError('required') &&
                                            clientForm.controls['taxrate'].touched
                                            ) {
                                            <small
                                              class="form-error-msg">
                                              {{ "addClient.form.taxRateRequired" | translate }}
                                            </small>
                                          }
                                          @if (
                                            clientForm.controls['taxrate'].hasError('min') &&
                                            clientForm.controls['taxrate'].touched
                                            ) {
                                            <small
                                              class="form-error-msg">
                                              {{ "addClient.form.taxRateMin" | translate }}
                                            </small>
                                          }
                                          @if (
                                            clientForm.controls['taxrate'].hasError('max') &&
                                            clientForm.controls['taxrate'].touched
                                            ) {
                                            <small
                                              class="form-error-msg">
                                              {{ "addClient.form.taxRateMax" | translate }}
                                            </small>
                                          }
                                        </div>
                                      </div>
                                    }
                                  </div>
                                  <div class="right">
                                    <div class="items">
                                      <label for="name">{{ "addClient.form.identifier" | translate }}*</label>
                                       <input
                                         [formControl]="clientForm.controls['identifier_customer']"
                                          [readonly]="customerFieldsReadOnly['identifier_customer']"
                                         type="text"
                                         [placeholder]="'addClient.form.identifierPlaceholder' | translate"
                                         autocomplete="off" />
                                        @if (
                                          clientForm.controls['identifier_customer'].hasError('required') &&
                                          clientForm.controls['identifier_customer'].touched
                                          ) {
                                          <small
                                            class="form-error-msg">
                                            {{ "addClient.form.identifierRequired" | translate }}</small
                                            >
                                        }
                                        @if (
                                          clientForm.controls['identifier_customer'].hasError('pattern') &&
                                          clientForm.controls['identifier_customer'].touched
                                          ) {
                                          <small
                                            class="form-error-msg">
                                            {{ "addClient.form.identifierInvalid" | translate }}</small
                                            >
                                          }
                                        </div>
                                        <div class="items">
                                          <label for="code_customer">{{ "addClient.form.code" | translate }}*</label>
                                          <input
                                            id="code_customer"
                                            [formControl]="clientForm.controls['code_customer']"
                                            [readonly]="customerForCards?.id != null"
                                            type="text"
                                            autocomplete="off" />
                                          @if (
                                            clientForm.controls['code_customer'].hasError('required') &&
                                            clientForm.controls['code_customer'].touched
                                            ) {
                                            <small class="form-error-msg">
                                              {{ "addClient.form.codeRequired" | translate }}
                                            </small>
                                          }
                                        </div>
                                        <div class="items">
                                          <label for="name">{{ "addClient.form.phone" | translate }}*</label>
                                          <input
                                           (keypress)="onlyNumberKey($event)"
                                           [formControl]="clientForm.controls['phoneNumber_customer']"
                                            [readonly]="customerFieldsReadOnly['phoneNumber_customer']"
                                           type="tel"
                                            [placeholder]="'addClient.form.phonePlaceholder' | translate"
                                            autocomplete="tel" />
                                            @if (
                                              clientForm.controls['phoneNumber_customer'].hasError('required') &&
                                              clientForm.controls['phoneNumber_customer'].touched
                                              ) {
                                              <small
                                                class="form-error-msg">
                                                {{ "addClient.form.phoneRequired" | translate }}</small
                                                >
                                            }
                                            @if (
                                              clientForm.controls['phoneNumber_customer'].hasError('pattern') &&
                                              clientForm.controls['phoneNumber_customer'].touched
                                              ) {
                                              <small
                                                class="form-error-msg">
                                                {{ "addClient.form.phonePattern" | translate }}</small
                                                >
                                              }
                                            </div>

                                            @if (mode === 'subscription') {
                                              <div
                                                class="items"
                                                >
                                                <label for="country">{{ "addClient.form.plan" | translate }}*</label>
                                                <div class="select-wrapper">
                                                  <select [formControl]="clientForm.controls['plan']">
                                                    <option
                                                      selected=""
                                                      value="">
                                                      {{ "addClient.form.planPlaceholder" | translate }}
                                                    </option>
                                                    @for (plan of plans; track plan) {
                                                      <option
                                                        [value]="plan.id">
                                                        {{ plan.name_plan }}
                                                      </option>
                                                    }
                                                  </select>
                                                  <i class="arrow"></i>
                                                  @if (
                                                    clientForm.controls['plan'].hasError('required') &&
                                                    clientForm.controls['plan'].touched
                                                    ) {
                                                    <small
                                                      class="form-error-msg">
                                                      {{ "addClient.form.planRequired" | translate }}
                                                    </small>
                                                  }
                                                </div>
                                              </div>
                                            }

                                            @if (mode === 'subscription' && isVariablePlan) {
                                              <div
                                                class="items"
                                                >
                                                <label for="customAmount">Monto personalizado*</label>
                                                <input
                                                  id="customAmount"
                                                  type="number"
                                                  step="0.01"
                                                  min="0.01"
                                                  formControlName="customAmount"
                                                  placeholder="Ej: 49.99" />
                                                  <small class="form-helper-msg"
                                                    >El monto personalizado debe incluir los taxes.</small
                                                    >
                                                    @if (
                                                      clientForm.controls['customAmount'].hasError('required') &&
                                                      clientForm.controls['customAmount'].touched
                                                      ) {
                                                      <small
                                                        class="form-error-msg">
                                                        Monto personalizado es requerido
                                                      </small>
                                                    }
                                                    @if (
                                                      clientForm.controls['customAmount'].hasError('min') &&
                                                      clientForm.controls['customAmount'].touched
                                                      ) {
                                                      <small
                                                        class="form-error-msg">
                                                        Monto debe ser mayor a 0
                                                      </small>
                                                    }
                                                  </div>
                                                }

                                                @if (mode === 'subscription' && isVariablePlan) {
                                                  <div
                                                    class="items"
                                                    >
                                                    <label for="customTaxRate">Impuesto personalizado (%)</label>
                                                    <input
                                                      id="customTaxRate"
                                                      type="number"
                                                      step="0.01"
                                                      min="0"
                                                      max="100"
                                                      formControlName="customTaxRate"
                                                      placeholder="Opcional. Ej: 7" />
                                                      <small class="form-helper-msg"
                                                        >Los taxes indicados ya deben estar incluidos en el monto personalizado.</small
                                                        >
                                                        @if (
                                                          clientForm.controls['customTaxRate'].hasError('min') &&
                                                          clientForm.controls['customTaxRate'].touched
                                                          ) {
                                                          <small
                                                            class="form-error-msg">
                                                            Impuesto debe ser mayor o igual a 0
                                                          </small>
                                                        }
                                                        @if (
                                                          clientForm.controls['customTaxRate'].hasError('max') &&
                                                          clientForm.controls['customTaxRate'].touched
                                                          ) {
                                                          <small
                                                            class="form-error-msg">
                                                            Impuesto debe ser menor o igual a 100
                                                          </small>
                                                        }
                                                      </div>
                                                    }
                                                    <!-- <div class="items">
                                                    <label >Corregimiento*</label>
                                                    <div class="select-wrapper">
                                                      <select [formControl]="clientForm.controls['corregimiento']" id="corregimiento" name="corregimiento">
                                                        <option   selected="" value="">Seleccione un opción</option>
                                                        <option *ngFor="let c of corregimientos" [value]="c.id" >{{c.name}}</option>
                                                      </select>
                                                      <i class="arrow"></i>
                                                      <small  *ngIf="clientForm.controls['corregimiento'].hasError('required') && clientForm.controls['corregimiento'].touched"
                                                        class="form-error-msg"> Corregimiento es requerido
                                                      </small>
                                                    </div>
                                                  </div> -->
                                                  @if (mode === 'onetime_payment') {
                                                    <div
                                                      class="items"
                                                      >
                                                      <label for="payment_description"
                                                        >{{ "addClient.form.paymentDescription" | translate }}*</label
                                                        >
                                                        <textarea
                                                          id="payment_description"
                                                          [placeholder]="'addClient.form.paymentDescriptionPlaceholder' | translate"
                                                          [formControl]="clientForm.controls['payment_description']"
                                                          rows="2"
                                                        style="resize: vertical"></textarea>
                                                        @if (
                                                          clientForm.controls['payment_description'].hasError('required') &&
                                                          clientForm.controls['payment_description'].touched
                                                          ) {
                                                          <small
                                                            class="form-error-msg">
                                                            {{ "addClient.form.descriptionRequired" | translate }}
                                                          </small>
                                                        }
                                                      </div>
                                                    }
                                                    @if (mode === 'subscription') {
                                                      <div
                                                        class="items"
                                                        >
                                                        <label>{{ "addClient.form.startDate" | translate }}*</label>
                                                        <div
                                                          fxFlex="100"
                                                          fxFlex.gt-xs="50"
                                                          class="pr-16">
                                                          <div class="pb-16">
                                                            <mat-form-field class="full-width">
                                                              <!--                                            <mat-label>Hasta</mat-label>-->
                                                              <input
                                                                matInput
                                                                [matDatepicker]="pickerHasta"
                                                                [placeholder]="'addClient.form.startDatePlaceholder' | translate"
                                                                formControlName="start_date"
                                                                name="until" />
                                                                <mat-datepicker-toggle
                                                                  matSuffix
                                                                [for]="pickerHasta"></mat-datepicker-toggle>
                                                                <mat-datepicker #pickerHasta></mat-datepicker>
                                                              </mat-form-field>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      }
                                                      <div>
                                                        <!-- Solo mostrar en modo subscription -->
                                                        @if (mode === 'subscription') {
                                                          <button
                                                            class="continue-btn color big"
                    [disabled]="
                      !canCreateCustomer() ||
                      !canSuscribeCustomer() ||
                      !canGenerateCreditCardToken()
                    "
                                                            (click)="togglePopup(true)">
                                                            {{ "addClient.buttons.affiliate" | translate }}
                                                          </button>
                                                          {{ "addClient.buttons.or" | translate }}
                                                          <button
                                                            class="continue-btn big"
                                                            [disabled]="!canCreateCustomer() || !canSuscribeCustomer()"
                                                            (click)="send(true)">
                                                            {{ "addClient.buttons.sendEmail" | translate }}
                                                          </button>
                                                        } @else {
                                                          <button
                                                            class="continue-btn big"
                                                            [disabled]="!canCreateCustomer() || !canSuscribeCustomer()"
                                                            (click)="send(true)">
                                                            {{ "addClient.buttons.sendEmail" | translate }}
                                                          </button>
                                                        }

                                                        <!-- Solo mostrar en modo onetime_payment -->
                                                      </div>
                                                    </div>
                                                  </div>
                                              </form>
                                            }
                                            </div>
                                            <hr style="margin-top: 25px; margin-bottom: 25px" />
                                              <!--nueva tabla enviados -->
                                              <div class="second-headboard">
                                                <h2>
                                                  {{
                                                  mode === "onetime_payment"
                                                  ? ("addClient.titles.pendingPayment" | translate)
                                                  : ("addClient.titles.pending" | translate)
                                                  }}
                                                </h2>
                                                <p>
                                                  {{
                                                  mode === "onetime_payment"
                                                  ? ("addClient.descriptions.pendingPayment" | translate)
                                                  : ("addClient.descriptions.pending" | translate)
                                                  }}
                                                </p>
                                                <p></p>
                                              </div>

                                              <div class="search-bar">
                                                <mat-form-field
                                                  appearance="fill"
                                                  class="search-field">
                                                  <mat-label>{{ "addClient.table.searchLabel" | translate }}</mat-label>
                                                  <input
                                                    matInput
                                                    (keyup)="applyFilter($event.target.value)" />
                                                  </mat-form-field>
                                                  <button
                                                    mat-raised-button
                                                    color="primary"
                                                    class="btn-resend-selected"
                                                    [disabled]="!tableService.selection.hasValue()"
                                                    (click)="resendEmailsToSelected()">
                                                    {{ "addClient.buttons.resendSelected" | translate }}
                                                  </button>
                                                  <button
                                                    mat-stroked-button
                                                    class="btn-cancel"
                                                    [disabled]="!tableService.selection.hasValue()"
                                                    (click)="cancelSuscriptionsSelected()">
                                                    {{ "addClient.buttons.cancelSelected" | translate }}
                                                  </button>
                                                </div>

                                                <div class="table-container">
                                                  <mat-table
                                                    [dataSource]="dataSource"
                                                    class="mat-elevation-z8">
                                                    <ng-container matColumnDef="select">
                                                      <th
                                                        mat-header-cell
                                                        *matHeaderCellDef>
                                                        <mat-checkbox
                                                          (change)="tableService.masterToggle(dataSource.data)"
                [checked]="
                  tableService.selection.hasValue() &&
                  tableService.isAllSelected(dataSource.data.length)
                "
                [indeterminate]="
                  tableService.selection.hasValue() &&
                  !tableService.isAllSelected(dataSource.data.length)
                "></mat-checkbox>
                                                      </th>
                                                      <td
                                                        mat-cell
                                                        *matCellDef="let row">
                                                        <mat-checkbox
                                                          (click)="$event.stopPropagation()"
                                                          (change)="tableService.selection.toggle(row)"
                                                        [checked]="tableService.selection.isSelected(row)"></mat-checkbox>
                                                      </td>
                                                    </ng-container>

                                                    <ng-container matColumnDef="ID">
                                                      <th
                                                        mat-header-cell
                                                        *matHeaderCellDef>
                                                        {{ "addClient.table.id" | translate }}
                                                      </th>
                                                      <td
                                                        mat-cell
                                                        *matCellDef="let user">
                                                        {{ user.id }}
                                                      </td>
                                                    </ng-container>

                                                    <ng-container matColumnDef="name_customer">
                                                      <th
                                                        mat-header-cell
                                                        *matHeaderCellDef
                                                        mat-sort-header>
                                                        {{ "addClient.table.name" | translate }}
                                                      </th>
                                                      <td
                                                        mat-cell
                                                        *matCellDef="let user">
                                                        {{ user.customerName }}
                                                      </td>
                                                    </ng-container>

                                                    <ng-container matColumnDef="email_customer">
                                                      <th
                                                        mat-header-cell
                                                        *matHeaderCellDef
                                                        mat-sort-header>
                                                        {{ "addClient.table.email" | translate }}
                                                      </th>
                                                      <td
                                                        mat-cell
                                                        *matCellDef="let user">
                                                        {{ user.customerEmail }}
                                                      </td>
                                                    </ng-container>

                                                    <ng-container matColumnDef="actions">
                                                      <th
                                                        mat-header-cell
                                                        *matHeaderCellDef>
                                                        {{ "addClient.table.action" | translate }}
                                                      </th>
                                                      <td
                                                        class="action"
                                                        *matCellDef="let user">
                                                        <button
                                                          mat-raised-button
                                                          class="btn-resend"
                                                          (click)="resendEmail(user)">
                                                          {{ "addClient.buttons.resend" | translate }}
                                                        </button>
                                                        <button
                                                          mat-stroked-button
                                                          class="btn-copy-link"
                                                          (click)="copyLinkFromTable(user)">
                                                          <mat-icon>content_copy</mat-icon>
                                                          {{ "addClient.buttons.copyLink" | translate }}
                                                        </button>
                                                        <button
                                                          mat-stroked-button
                                                          class="btn-cancel-2"
                                                          (click)="cancelSubscription(user)">
                                                          {{
                                                          mode === "onetime_payment"
                                                          ? ("addClient.buttons.cancelPayment" | translate)
                                                          : ("addClient.buttons.cancelSubscription" | translate)
                                                          }}
                                                        </button>
                                                      </td>
                                                    </ng-container>

                                                    <tr
                                                      mat-header-row
                                                    *matHeaderRowDef="displayedColumns"></tr>
                                                    <tr
                                                      mat-row
                                                    *matRowDef="let row; columns: displayedColumns"></tr>
                                                  </mat-table>

                                                  <mat-paginator
                                                    [length]="tableService.pager.totalEntities"
                                                    [pageIndex]="tableService.pager.pageIndex"
                                                    [pageSize]="tableService.pager.pageSize"
                                                    [pageSizeOptions]="[20, 50, 100]"
                                                  (page)="list($event)"></mat-paginator>
                                                  @if (mode === 'onetime_payment' && dataSource?.data?.length === 0) {
                                                    <div
                                                      class="no-results-message">
                                                      <p>{{ "addClient.table.noOnetimePayments" | translate }}</p>
                                                    </div>
                                                  }
                                                </div>

                                                <!--end nueva tabla enviados -->
                                                <!-- Modal -->
                                                <div
                                                  class="modal-overlay"
                                                  [ngClass]="{ show: isPopupVisible }">
                                                  <div class="modal-content">
                                                    <button
                                                      class="close-btn"
                                                      (click)="togglePopup(false)">
                                                      X
                                                    </button>
                                                    <h1>{{ "addClient.paymentModal.title" | translate }}</h1>

                                                    <!-- Modo de selección: solo mostrar si hay tarjetas guardadas -->
                                                    @if (tarjetasGuardadas.length > 0) {
                                                      <div
                                                        class="modo-seleccion"
                                                        style="margin-bottom: 20px">
                                                        <h3 style="margin-bottom: 15px; margin-top: 15px; font-size: 16px; color: #333">
                                                          {{ "addClient.paymentModal.selectMethod" | translate }}
                                                        </h3>
                                                        <div style="display: flex; gap: 20px">
                                                          <label style="display: flex; align-items: center; cursor: pointer">
                                                            <input
                                                              type="radio"
                                                              name="modoTarjeta"
                                                              [(ngModel)]="usarTarjetaGuardada"
                                                              [value]="true"
                                                              style="margin-right: 8px" />
                                                              <span>{{ "addClient.paymentModal.useSavedCard" | translate }}</span>
                                                            </label>
                                                            <label style="display: flex; align-items: center; cursor: pointer">
                                                              <input
                                                                type="radio"
                                                                name="modoTarjeta"
                                                                [(ngModel)]="usarTarjetaGuardada"
                                                                [value]="false"
                                                                style="margin-right: 8px" />
                                                                <span>{{ "addClient.paymentModal.useNewCard" | translate }}</span>
                                                              </label>
                                                            </div>
                                                          </div>
                                                        }

                                                        <!-- Sección de tarjetas guardadas -->
                                                        @if (usarTarjetaGuardada && tarjetasGuardadas.length > 0) {
                                                          <div
                                                            class="tarjetas-guardadas-section">
                                                            <h3 style="margin-bottom: 15px; font-size: 16px; color: #333">
                                                              {{ "addClient.paymentModal.customerCards" | translate }}
                                                            </h3>
                                                            <div
                                                              class="tarjetas-lista"
              style="
                max-height: 400px;
                overflow-y: auto;
                display: grid;
                grid-template-columns: repeat(2, 1fr);
                gap: 15px;
                padding: 5px;
              ">
                                                              @for (tarjeta of tarjetasGuardadas; track tarjeta) {
                                                                <div
                                                                  class="tarjeta-card"
                                                                  [class.selected]="tarjetaSeleccionadaId === tarjeta.id"
                                                                  (click)="tarjetaSeleccionadaId = tarjeta.id"
                style="
                  border: 2px solid #ddd;
                  border-radius: 8px;
                  padding: 15px;
                  cursor: pointer;
                  transition: all 0.3s ease;
                  display: flex;
                  align-items: center;
                  gap: 12px;
                "
                                                                  [style.border-color]="tarjetaSeleccionadaId === tarjeta.id ? '#4CAF50' : '#ddd'"
                [style.background-color]="
                  tarjetaSeleccionadaId === tarjeta.id ? '#f0f9ff' : 'white'
                ">
                                                                  <input
                                                                    type="radio"
                                                                    name="tarjetaSeleccionada"
                                                                    [value]="tarjeta.id"
                                                                    [(ngModel)]="tarjetaSeleccionadaId"
                                                                    style="cursor: pointer; flex-shrink: 0" />
                                                                    <div
                                                                      class="tarjeta-info"
                                                                      style="flex: 1; min-width: 0">
                                                                      <div
                    style="
                      font-weight: 600;
                      font-size: 14px;
                      margin-bottom: 5px;
                      color: #333;
                      white-space: nowrap;
                      overflow: hidden;
                      text-overflow: ellipsis;
                    ">
                                                                        {{
                                                                        tarjeta.nameHolderCreditCard ||
                                                                        ("addClient.paymentModal.cardholderNotAvailable" | translate)
                                                                        }}
                                                                      </div>
                                                                      <div
                    style="
                      font-size: 13px;
                      color: #666;
                      margin-bottom: 3px;
                      display: flex;
                      align-items: center;
                      gap: 6px;
                      flex-wrap: wrap;
                    ">
                                                                        <span style="white-space: nowrap">{{
                                                                          tarjeta.maskCreditCard || tarjeta.mask_card || "****-****"
                                                                        }}</span>
                                                                        @if (tarjeta.creditCardProvider) {
                                                                          <span
                      style="
                        background: #e3f2fd;
                        padding: 2px 6px;
                        border-radius: 4px;
                        font-size: 10px;
                        font-weight: 500;
                        color: #1976d2;
                        white-space: nowrap;
                      ">
                                                                            {{ tarjeta.creditCardProvider.description }}
                                                                          </span>
                                                                        }
                                                                      </div>
                                                                      <div style="font-size: 12px; color: #999">
                                                                        {{ "addClient.paymentModal.expires" | translate }}
                                                                        {{ tarjeta.expiration_month || tarjeta.expMonthCreditCard }}/{{
                                                                        tarjeta.expiration_year || tarjeta.expYearCreditCard
                                                                        }}
                                                                      </div>
                                                                    </div>
                                                                  </div>
                                                                }
                                                              </div>
                                                            </div>
                                                          }

                                                          <!-- Formulario de nueva tarjeta -->
                                                          @if (!usarTarjetaGuardada || tarjetasGuardadas.length === 0) {
                                                            <div>
                                                              <form [formGroup]="paymentForm">
                                                                <div class="">
                                                                  <div class="left">
                                                                    <div class="items">
                                                                      <label for="name">{{
                                                                        "addClient.paymentModal.cardholderName" | translate
                                                                      }}</label>
                                                                      <input
                                                                        [formControl]="paymentForm.controls['nameHolderCreditCard']"
                                                                        type="text"
                                                                        [placeholder]="'addClient.form.namePlaceholder' | translate" />
                                                                        @if (
                                                                          paymentForm.controls['nameHolderCreditCard'].hasError('required') &&
                                                                          paymentForm.controls['nameHolderCreditCard'].touched
                                                                          ) {
                                                                          <small
                                                                            class="form-error-msg">
                                                                            {{ "addClient.paymentModal.cardholderNameRequired" | translate }}</small
                                                                            >
                                                                        }
                                                                        @if (
                                                                          paymentForm.controls['nameHolderCreditCard'].hasError('minlength') &&
                                                                          paymentForm.controls['nameHolderCreditCard'].touched
                                                                          ) {
                                                                          <small
                                                                            class="form-error-msg">
                                                                            {{ "addClient.paymentModal.cardholderNameMinLength" | translate }}</small
                                                                            >
                                                                          }
                                                                          @if (
                                                                            paymentForm.controls['nameHolderCreditCard'].hasError('pattern') &&
                                                                            !paymentForm.controls['nameHolderCreditCard'].hasError('minlength') &&
                                                                            paymentForm.controls['nameHolderCreditCard'].touched
                                                                            ) {
                                                                            <small
                                                                              class="form-error-msg">
                                                                              {{ "addClient.paymentModal.cardholderNamePattern" | translate }}</small
                                                                              >
                                                                            }
                                                                          </div>
                                                                          <div class="items">
                                                                            <label for="name">{{ "addClient.paymentModal.cardNumber" | translate }}</label>
                                                                            <input
                                                                              type="text"
                                                                              autocomplete="cc-number"
                                                                              inputmode="numeric"
                                                                              maxlength="23"
                                                                              [value]="creditCardNumberMasked"
                                                                              (input)="onCardInput($event)"
                                                                              formControlName="numberCreditCard"
                                                                              placeholder="1234-5678-9012-3456" />
                                                                              @if (
                                                                                paymentForm.controls['numberCreditCard'].hasError('cardLength') &&
                                                                                paymentForm.controls['numberCreditCard'].touched
                                                                                ) {
                                                                                <small
                                                                                  class="form-error-msg"
                                                                                  style="color: red">
                                                                                  {{ "addClient.paymentModal.cardNumberLength" | translate }}</small
                                                                                  >
                                                                              }
                                                                              @if (
                                                                                paymentForm.controls['numberCreditCard'].hasError('luhn') &&
                                                                                !paymentForm.controls['numberCreditCard'].hasError('cardLength') &&
                                                                                paymentForm.controls['numberCreditCard'].touched
                                                                                ) {
                                                                                <small
                                                                                  class="form-error-msg"
                                                                                  style="color: red">
                                                                                  {{ "addClient.paymentModal.cardNumberInvalid" | translate }}</small
                                                                                  >
                                                                                }
                                                                                @if (
                                                                                  paymentForm.controls['numberCreditCard'].hasError('required') &&
                                                                                  paymentForm.controls['numberCreditCard'].touched
                                                                                  ) {
                                                                                  <small
                                                                                    class="form-error-msg">
                                                                                    {{ "addClient.paymentModal.cardNumberRequired" | translate }}</small
                                                                                    >
                                                                                  }
                                                                                </div>
                                                                                <div class="grid">
                                                                                  <div class="items">
                                                                                    <label for="country">{{
                                                                                      "addClient.paymentModal.expirationMonth" | translate
                                                                                    }}</label>
                                                                                    <div class="select-wrapper">
                                                                                      <select [formControl]="paymentForm.controls['expMonthCreditCard']">
                                                                                        <option
                                                                                          value=""
                                                                                          disabled
                                                                                          selected>
                                                                                          {{ "addClient.paymentModal.selectMonth" | translate }}
                                                                                        </option>
                                                                                        <option
                                                                                          value="01"
                                                                                          id="mes-exp-0">
                                                                                          {{ "addClient.paymentModal.months.january" | translate }}
                                                                                        </option>
                                                                                        <option
                                                                                          value="02"
                                                                                          id="mes-exp-1">
                                                                                          {{ "addClient.paymentModal.months.february" | translate }}
                                                                                        </option>
                                                                                        <option
                                                                                          value="03"
                                                                                          id="mes-exp-2">
                                                                                          {{ "addClient.paymentModal.months.march" | translate }}
                                                                                        </option>
                                                                                        <option
                                                                                          value="04"
                                                                                          id="mes-exp-3">
                                                                                          {{ "addClient.paymentModal.months.april" | translate }}
                                                                                        </option>
                                                                                        <option
                                                                                          value="05"
                                                                                          id="mes-exp-4">
                                                                                          {{ "addClient.paymentModal.months.may" | translate }}
                                                                                        </option>
                                                                                        <option
                                                                                          value="06"
                                                                                          id="mes-exp-5">
                                                                                          {{ "addClient.paymentModal.months.june" | translate }}
                                                                                        </option>
                                                                                        <option
                                                                                          value="07"
                                                                                          id="mes-exp-6">
                                                                                          {{ "addClient.paymentModal.months.july" | translate }}
                                                                                        </option>
                                                                                        <option
                                                                                          value="08"
                                                                                          id="mes-exp-7">
                                                                                          {{ "addClient.paymentModal.months.august" | translate }}
                                                                                        </option>
                                                                                        <option
                                                                                          value="09"
                                                                                          id="mes-exp-8">
                                                                                          {{ "addClient.paymentModal.months.september" | translate }}
                                                                                        </option>
                                                                                        <option
                                                                                          value="10"
                                                                                          id="mes-exp-9">
                                                                                          {{ "addClient.paymentModal.months.october" | translate }}
                                                                                        </option>
                                                                                        <option
                                                                                          value="11"
                                                                                          id="mes-exp-10">
                                                                                          {{ "addClient.paymentModal.months.november" | translate }}
                                                                                        </option>
                                                                                        <option
                                                                                          value="12"
                                                                                          id="mes-exp-11">
                                                                                          {{ "addClient.paymentModal.months.december" | translate }}
                                                                                        </option>
                                                                                      </select>
                                                                                      <i class="arrow"></i>
                                                                                      @if (
                                                                                        paymentForm.controls['expMonthCreditCard'].hasError('required') &&
                                                                                        paymentForm.controls['expMonthCreditCard'].touched
                                                                                        ) {
                                                                                        <small
                                                                                          class="form-error-msg">
                                                                                          {{ "addClient.paymentModal.monthRequired" | translate }}
                                                                                        </small>
                                                                                      }
                                                                                    </div>
                                                                                  </div>
                                                                                  <div class="items">
                                                                                    <label for="country">{{
                                                                                      "addClient.paymentModal.expirationYear" | translate
                                                                                    }}</label>
                                                                                    <div class="select-wrapper">
                                                                                      <select [formControl]="paymentForm.controls['expYearCreditCard']">
                                                                                        <option
                                                                                          value=""
                                                                                          disabled
                                                                                          selected>
                                                                                          {{ "addClient.paymentModal.selectYear" | translate }}
                                                                                        </option>
                                                                                        @for (year of expirationYears; track year) {
                                                                                          <option
                                                                                            [value]="year.value">
                                                                                            {{ year.label }}
                                                                                          </option>
                                                                                        }
                                                                                      </select>
                                                                                      <i class="arrow"></i>
                                                                                      @if (
                                                                                        paymentForm.controls['expYearCreditCard'].hasError('required') &&
                                                                                        paymentForm.controls['expYearCreditCard'].touched
                                                                                        ) {
                                                                                        <small
                                                                                          class="form-error-msg">
                                                                                          {{ "addClient.paymentModal.yearRequired" | translate }}
                                                                                        </small>
                                                                                      }
                                                                                    </div>
                                                                                  </div>
                                                                                </div>
                                                                                @if (
                                                                                  paymentForm.hasError('expired') &&
                                                                                  (paymentForm.controls['expMonthCreditCard'].touched ||
                                                                                  paymentForm.controls['expYearCreditCard'].touched)
                                                                                  ) {
                                                                                  <small
                                                                                    class="form-error-msg"
                                                                                    style="color: red">
                                                                                    {{ "addClient.paymentModal.cardExpired" | translate }}</small
                                                                                    >
                                                                                  }
                                                                                  <div class="items">
                                                                                    <label for="name">{{ "addClient.paymentModal.cvv" | translate }}</label>
                                                                                    <input
                                                                                      (keypress)="onlyNumberKey($event)"
                                                                                      [formControl]="paymentForm.controls['ccv']"
                                                                                      type="text"
                                                                                      placeholder="CVV"
                                                                                      [maxlength]="cvvMaxLength"
                                                                                      inputmode="numeric" />
                                                                                      @if (
                                                                                        paymentForm.controls['ccv'].hasError('pattern') &&
                                                                                        paymentForm.controls['ccv'].touched
                                                                                        ) {
                                                                                        <small
                                                                                          class="form-error-msg">
                                                                                          {{
                                                                                          "addClient.paymentModal.cvvInvalid" | translate: { length: cvvMaxLength }
                                                                                          }}</small
                                                                                          >
                                                                                      }
                                                                                    </div>
                                                                                  </div>
                                                                                </div>
                                                                              </form>
                                                                            </div>
                                                                          }

                                                                          <button
                                                                            class="continue-btn"
            [disabled]="
              !canCreateCustomer() || !canSuscribeCustomer() || !canGenerateCreditCardToken()
            "
                                                                            (click)="send(false)">
                                                                            {{ "addClient.paymentModal.affiliateButton" | translate }}
                                                                          </button>
                                                                        </div>
                                                                      </div>

                                                                      <!-- Modal de Link de Afiliación -->
                                                                      <div
                                                                        class="modal-overlay"
                                                                        [ngClass]="{ show: showLinkModal }">
                                                                        <div
                                                                          class="modal-content"
                                                                          style="max-width: 600px">
                                                                          <button
                                                                            class="close-btn2"
                                                                            (click)="closeLinkModal()">
                                                                            X
                                                                          </button>
                                                                          <h1>{{ "addClient.linkModal.title" | translate }}</h1>
                                                                          <p style="margin-bottom: 20px; color: #666">
                                                                            {{ "addClient.linkModal.subtitle" | translate }}
                                                                          </p>

                                                                          <div style="margin-bottom: 20px">
                                                                            <label style="display: block; margin-bottom: 8px; font-weight: 600; color: #333"
                                                                              >{{ "addClient.linkModal.linkLabel" | translate }}
                                                                              {{
                                                                              mode === "onetime_payment"
                                                                              ? ("addClient.linkModal.payment" | translate)
                                                                              : ("addClient.linkModal.subscription" | translate)
                                                                              }}</label
                                                                              >
                                                                              <div style="display: flex; gap: 10px; align-items: center">
                                                                                <input
                                                                                  type="text"
                                                                                  [value]="subscriptionLink"
                                                                                  readonly
                style="
                  flex: 1;
                  padding: 12px;
                  border: 1px solid #ddd;
                  border-radius: 6px;
                  background: #f5f5f5;
                  font-size: 14px;
                  font-family: monospace;
                "
                                                                                  (click)="$event.target.select()" />
                                                                                </div>
                                                                                <small style="display: block; margin-top: 8px; color: #666; font-size: 13px">
                                                                                  {{ "addClient.linkModal.linkNote" | translate }}
                                                                                </small>
                                                                              </div>

                                                                              <div class="modal-buttons">
                                                                                <button
                                                                                  class="continue-btn"
                                                                                  [class.copied]="linkCopied"
                                                                                  (click)="copyLinkToClipboard()">
                                                                                  {{
                                                                                  linkCopied
                                                                                  ? ("addClient.linkModal.copied" | translate)
                                                                                  : ("addClient.linkModal.copyLink" | translate)
                                                                                  }}
                                                                                </button>
                                                                                <button
                                                                                  class="continue-btn whatsapp-btn"
                                                                                  (click)="shareViaWhatsApp()">
                                                                                  {{ "addClient.linkModal.shareWhatsApp" | translate }}
                                                                                </button>
                                                                              </div>

                                                                              <button
                                                                                class="back-btn"
                                                                                (click)="closeLinkModal()">
                                                                                {{ "addClient.linkModal.done" | translate }}
                                                                              </button>
                                                                            </div>
                                                                          </div>
                                                                        </div>
                                                                        <div class="options-buttons">
                                                                          <button
                                                                            class="back-btn"
                                                                            (click)="goBack()">
                                                                            {{ "common.back" | translate }}
                                                                          </button>
                                                                          <!-- <button class="continue-btn" (click)="send(false)" >Afiliar</button> -->
                                                                        </div>
                                                                      </div>
                                                                    </body>
